import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TypeDataInProgress, TypesProperty } from '@models';
import { ScheduleVisitService } from '../schedule-visit.service';

@Component({
  selector: 'ggi-journey-choose-department',
  templateUrl: './choose-department.component.html',
  styleUrls: ['./choose-department.component.scss'],
})
export class ChooseDepartmentComponent implements OnInit {
  @Input() typesProperty: TypesProperty[] = [];
  @Input() typePropertySelected: TypesProperty;
  @Output() canUserContinue = new EventEmitter<boolean>();
  @Output() nextStep = new EventEmitter<MouseEvent>();

  public items: TypesProperty[] = [];

  public image: string;

  public property: string;
  public existProperty: boolean;

  public emptyArray: number[] = [];
  public featuresCount: number;

  constructor(
    private readonly service: ScheduleVisitService,
    private readonly route: ActivatedRoute
  ) {}

  public ngOnInit(): void {
    this.items = this.typesProperty;
    this.setProperty();
  }

  /**
   * Assing property if property id is received as a query param
   */
  public setProperty(): void {
    this.route.queryParams.subscribe((res) => {
      this.property = res.property;
      if (this.property) {
        const prop = this.items.find(
          (item: TypesProperty) => item.id === this.property
        );
        if (prop) {
          this.setDepartment(prop);
        }
      }
    });
  }
  /**
   * Set department selected to visit
   * @param selected property selected
   */
  public setDepartment(selected: TypesProperty): void {
    this.typePropertySelected = selected;

    this.featuresCount = this.typePropertySelected.features.length;
    if (this.featuresCount <= 18) {
      if (this.featuresCount > 9) {
        this.emptyArray = Array.from(Array(18 - this.featuresCount).keys());
      }
    } else if (this.featuresCount % 2 === 1) {
      this.emptyArray = [0];
    }

    const { id, detail, label } = selected;

    this.service.saveDataInProgress(
      { propertyId: id, propertyName: label },
      TypeDataInProgress.selectProperty
    );

    this.changeImage(detail);
    this.canUserContinue.emit(true);
  }

  private changeImage(src: string): void {
    this.image = src;
  }
}
